<div class="breadcrumbs overlay">
    <div class="container">
        <div class="bread-inner">
            <div class="row">
                <div class="col-12">
                    <h2>Rapports et Travaux de la Cour des Comptes du Bénin</h2>
                </div>
            </div>
        </div>
    </div>
</div>
<br>

<body>
    <main class="container my-4">
        <div class="row mb-3">
            <div class="col-12">
                <div class="card">
                    <div class="card-body ">
                        <p class="text-center">La Cour des Comptes du Bénin joue un rôle essentiel dans le contrôle des finances publiques et l'amélioration de la gouvernance. Ses travaux contribuent à la transparence et à la bonne gestion des fonds publics au Bénin.</p>
                        <ul class=" text-center align-content-center">
                            <p> <strong><i class="pi pi-check-circle" style="font-size: 1rem"></i>
                                    Contrôle des comptes des ministères et services de l'État.</strong> </p>
                            <p><strong><i class="pi pi-check-circle" style="font-size: 1rem"></i>
                                    Audit des établissements publics et des collectivités territoriales.</strong></p>
                                    <p><strong><i class="pi pi-check-circle" style="font-size: 1rem"></i>
                                     Publication des rapports annuels et travaux spéciaux.</strong></p>
                        </ul>
                        <p class="text-center">Ces travaux permettent d'améliorer la transparence, l'efficacité et la régularité dans la gestion des finances publiques du Bénin.</p>

                    </div>
                </div>
            </div>
        </div>

        <!-- Sections avec des cartes uniformes -->
        <div class="row g-4">

            <!-- Section 1 -->
            <div class="col-md-6">
                <div class="card h-100">
                    <div class="card-body">
                        <h5 class="card-title text-center">Contrôle des Comptes Publics</h5>
                        <p>La Cour des Comptes du Bénin exerce le contrôle a posteriori sur les comptes des administrations publiques. Elle vérifie la régularité, la sincérité et la bonne utilisation des fonds publics conformément aux lois et règlements en vigueur.</p>

                    </div>
                </div>
            </div>

            <!-- Section 2 -->
            <div class="col-md-6">
                <div class="card h-100">
                    <div class="card-body">
                        <h5 class="card-title text-center">Audit des Établissements Publics</h5>
                        <p>La Cour assure le contrôle des comptes et de la gestion financière des établissements publics de l'État, des entreprises du portefeuille de l'État et des collectivités territoriales décentralisées.</p>
                    </div>
                </div>
            </div>

            <!-- Section 3 -->
            <div class="col-md-6">
                <div class="card h-100">
                    <div class="card-body">
                        <h5 class="card-title text-center">Rapports Annuels</h5>
                        <p>Chaque année, la Cour des Comptes publie un rapport annuel contenant les résultats du contrôle des comptes et des gestionnaires publics, ainsi que des observations et recommandations pour améliorer la gestion des finances publiques.</p>
                    </div>
                </div>
            </div>

            <!-- Section 4 -->
            <div class="col-md-6">
                <div class="card h-100">
                    <div class="card-body">
                        <h5 class="card-title text-center">Soutien au Parlement</h5>
                        <p>La Cour appuie le Parlement dans l'exercice de son contrôle des finances publiques en lui fournissant des analyses, rapports et informations sur la gestion des deniers publics.</p>
                    </div>
                </div>
            </div>

            <!-- Section 5 -->
            <div class="col-md-12">
                <div class="card">
                    <div class="card-body">
                        <h5 class="card-title text-center">Perspectives</h5>
                        <p>La Cour des Comptes du Bénin continue de renforcer ses capacités d'intervention et d'améliorer ses méthodes de contrôle pour contribuer davantage à la bonne gouvernance et à la transparence dans la gestion des finances publiques au Bénin.</p>
                    </div>
                </div>
            </div>
        </div>
    </main>
    <script src="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0/dist/js/bootstrap.bundle.min.js"></script>
</body>
<br>
